import React from 'react';
import { toNumber } from 'lodash';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { PriceInputType } from '../ricFormTypes';
import { SectionInputItem, SubsectionInputItem } from '../Components';

const SchemaPriceInput = ({
  formElement,
  responseData,
  fetchResponseWithUpdatedData,
  isSubSectionElement,
}: {
  formElement: PriceInputType;
  isSubSectionElement: boolean;
  responseData: FinanceResponseData;
  fetchResponseWithUpdatedData: (data: Partial<FinanceResponseData>) => void;
}) => {
  const { title, subtitle, responseDataField, required } = formElement;

  const value = toNumber(responseData?.[responseDataField]);

  const InputComponent = isSubSectionElement
    ? SubsectionInputItem
    : SectionInputItem;

  return (
    <InputComponent
      title={title}
      subtitle={subtitle}
      value={value}
      field={responseDataField}
      onChange={fetchResponseWithUpdatedData}
      required={required}
    />
  );
};

export default SchemaPriceInput;
